<script setup>
    // Toggles ability of a user to log into the website. Does not suspend user from all activities, like using their media.

    import axios from 'axios';
    import Swal from 'sweetalert2';

    const props = defineProps(['fetchUrl', 'lockIcon', 'buttonText']);

    // immediately toggles suspension of a user. Shows succes with a SweetAlert2 modal.
    // On confirm, reloads the page, otherwise shows error message.
    function toggleSuspension() {
        axios.put(props.fetchUrl)
        .then((data) => {
            if (data) {
                if (data.status === 200) {
                    Swal.fire({
                        title: "Erfolgreich",
                        text: data.data.message,
                        icon: 'success',
                    }).then((result) => {
                        if (result.isConfirmed === true) {
                            window.location.reload();
                        }
                    });
                } else {
                    Swal.fire({
                        title: "Fehlgeschlagen",
                        text: data.data.message,
                        icon: 'error',
                    });
                }
                // no timeouts like earlier to make it disappear sooner.
                //The ServiceCenter needs to be able to see what they're doing at their own pace, even if they get interrupted!
            }
        }).catch(error => {
            Swal.fire({
                title: "Fehlgeschlagen",
                text: error.response.data.message,
                icon: 'error',
            });
        });
    }

</script>
<template>
    <button @click.prevent="toggleSuspension()" class="btn btn-primary" type="button">
        <i :class="'fa-solid ' + props.lockIcon"></i> {{ props.buttonText }}
    </button>
</template>
